var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoQlikWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1032 319.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-qlik") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M31.26,273.88a68,68,0,0,1-68,68,68,68,0,0,1-68-68,68,68,0,0,1,68-68,68,68,0,0,1,68,68M89.91,374.12s4.49-5.18-.67-9.68L60.89,339.8a117,117,0,0,0,20.18-65.92A117.82,117.82,0,0,0-36.75,156.05,117.83,117.83,0,0,0-154.57,273.88,117.83,117.83,0,0,0-36.75,391.71a117.17,117.17,0,0,0,64.47-19.29l31.08,27s5.19,4.51,9.69-.68Zm79.41,9.43V164.18c0-8-8-8-8-8H126c-8,0-8,8-8,8V383.56c0,8,8,8,8,8H161.3c8,0,8-8,8-8m86.73-197.1V163.78s0-7.73-7.74-7.73H214.37s-7.7,0-7.7,7.73v22.67s0,7.72,7.7,7.72h33.94s7.74,0,7.74-7.72m1.31,197.1V225.2c0-8-8-8-8-8H214.68c-8,0-8,8-8,8V383.55c0,8,8,8,8,8h34.65c8,0,8-8,8-8M405.9,286.41c-4.16-6.86,1.42-12.64,1.42-12.64l48.85-50.49c5.58-5.77-2.43-5.77-2.43-5.77H408.11c-8,0-13.55,5.84-13.55,5.84l-45.33,48c-5.5,5.83-5.5-2.18-5.5-2.18v-105c0-8-8-8-8-8h-34.6c-7.72,0-7.72,7.73-7.72,7.73V383.56c0,8,8,8,8,8h34.3c7.71,0,7.71-7.72,7.71-7.72v-38.6c0-8,5.84-13.52,5.84-13.52l16.16-15.19L406,384.69c4.11,6.89,12.14,6.89,12.14,6.89H461.4c8,0,3.88-6.86,3.88-6.86Z",
    transform: "translate(154.57 -118.7)",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.24,272.3a94.38,94.38,0,1,1-94.37-94.38,94.38,94.38,0,0,1,94.37,94.38m78.51,118-43-36.07a153.57,153.57,0,1,0-41.5,43.68l45.83,38.45s6.81,5.73,12.52-1.08l27.23-32.45s5.71-6.82-1.09-12.53",
    transform: "translate(154.57 -118.7)",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.37,272.29a60.49,60.49,0,1,1,60.49,60.51,60.47,60.47,0,0,1-60.49-60.51",
    transform: "translate(154.57 -118.7)",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.32,167.17h4.07c2.36,0,4-.52,4-3.26,0-2.34-1.77-3.24-4-3.24h-4.07Zm0,9.73h-2v-18h6.52c3.08,0,5.5,1.58,5.5,5,0,2.83-1.54,4.72-4.25,5l5,8h-2.46l-4.76-8h-3.63v8Zm3.39-21.7A12.46,12.46,0,0,0,850.36,168c0,7.13,5.3,12.75,12.35,12.75s12.35-5.62,12.35-12.75-5.29-12.76-12.35-12.76M848,168a14.72,14.72,0,1,1,14.71,14.72A14.75,14.75,0,0,1,848,168",
    transform: "translate(154.57 -118.7)",
    style: {
      fill: "#ffffff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoQlikWhite);
export default __webpack_public_path__ + "static/media/logo-qlik-white.61caee79c375783ba09228e94fd738b9.svg";
export { ForwardRef as ReactComponent };